import { render, staticRenderFns } from "./CoinStoreTransferHistory.vue?vue&type=template&id=2dbbb21f&scoped=true&"
import script from "./CoinStoreTransferHistory.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreTransferHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreTransferHistory.vue?vue&type=style&index=0&id=2dbbb21f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbbb21f",
  null
  
)

export default component.exports